module.exports = __webpack_public_path__ + "static/media/icon_spare_wheel.2e00d53e.svg";